<script lang="ts">
  import Map from '../Map/Map.svelte';
</script>

<article class="company-area">
  <section class="section-title" id="about">
    <h2>スパトレについて</h2>
  </section>

  <section class="company-profile content-inner">
    <h3 class="topic-title">会社概要</h3>
    <dl>
      <dt>社名</dt>
      <dd>スパトレ株式会社</dd>
      <dt>英文名称</dt>
      <dd>Spartan English training academy, Inc.</dd>
      <dt>代表取締役</dt>
      <dd>向井 麻里絵</dd>
      <dt>所在地</dt>
      <dd>〒101-0047 東京都千代田区内神田1-4-10 ATS大手町ビル5F</dd>
      <dt>電話番号</dt>
      <dd>03-4362-8615</dd>
      <dt>事業内容</dt>
      <dd>英語教授業</dd>
      <dt>設立</dt>
      <dd>2018年5月22日</dd>
    </dl>
  </section>

  <Map />

  <p class="map-text">
    〒101-0047 東京都千代田区内神田1-4-10 ATS大手町ビル5F
  </p>
</article>

<style>
  .company-profile,
  .company-history {
    padding: 40px 0;
    display: grid;
    grid-template-columns: 50% 1fr;
  }

  .company-profile dl {
    display: flex;
    flex-wrap: wrap;
    min-width: 470px;
  }

  .company-profile dt {
    width: 20%;
    margin: 0 0 15px 0;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.4;
    color: #000000;
  }

  .company-profile dd {
    width: 75%;
    margin: 0 0 15px 0;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.4;
    color: #000000;
  }

  .section-title {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    text-align: center;
    border-top: 1px solid #D0DBF7;
    border-bottom: 1px solid #D0DBF7;
    background-color: #F8F9FD;
    position: relative;
    left: 50%;
    right: 50%;
    transform: translateX(-50%);
  }

  .section-title h2 {
    width: 1000px;
    margin: 0 auto;
    height: 185px;
    display: inline-flex;
    align-items: center;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 43px;
    letter-spacing: 0.1em;
    color: #7521da;
  }

  .topic-title {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: bold;
    font-size: 2.5rem;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: #7521da;
  }

  .map-text {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2;
    text-align: justify;
    color: #000000;
  }

  @media screen and (max-width: 768px) {
    .company-profile,
    .company-history {
      display: flex;
      flex-direction: column;
      padding: 20px 0;
    }

    .company-profile dl {
      min-width: 100%;
    }

    .company-profile dt {
      font-size: 1.3rem;
      width: 40%;
    }

    .company-profile dd {
      font-size: 1.3rem;
      width: 55%;
    }

    .section-title h2 {
      width: 90%;
      height: 79px;
      font-size: 2rem;
    }

    .topic-title {
      font-size: 1.8rem;
    }
  }
</style>
